import api from './api';

// Assuming the backend returns arrays of these types
// These should be updated to match the actual Prisma models
export interface PaperType {
  id: string;
  name: string;
  brand: string;
  // Add other relevant fields
}

export interface Printer {
  id: string;
  name: string;
  brand: string;
  model: string;
  // Add other relevant fields
}

/**
 * Fetches all available paper types from the server.
 */
export const getPaperTypes = async (): Promise<PaperType[]> => {
  try {
    const response = await api.get<PaperType[]>('/papertypes');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch paper types:', error);
    throw error;
  }
};

/**
 * Fetches all available printers from the server.
 */
export const getPrinters = async (): Promise<Printer[]> => {
  try {
    const response = await api.get<Printer[]>('/printers');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch printers:', error);
    throw error;
  }
};
